// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e7guK","question":"styles_question__3z8R8","description":"styles_description__pubrS"};